import { Box, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";

type Props = {
  title: string;
  main?: boolean;
};

function DriverDetailsItem({ title, main = false, children }: PropsWithChildren<Props>) {
  return (
    <Box
      className="item"
      sx={{
        p: 2, // padding: 1rem
        minHeight: 100,
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          mb: 1, // margin-bottom: 0.5rem
        }}
      >
        {title}
      </Typography>

      <Box
        sx={
          !main
            ? {
                fontSize: "var(--large-font-size)",
                fontWeight: 400,
              }
            : undefined
        }
      >
        {children}
      </Box>
    </Box>
  );
}

export default DriverDetailsItem;
